import {
    collection,
    getVariantByParentType,
    parentTypeFor,
} from "../_variants/index.js";
import {
    makeAttached,
    makeDropdown
} from "../../../utils.js";

import store from "../../../store.js";

const isRepairsParent = (parentType) => parentType === "Repairs" || parentType === "MilitaryRepairs";

export const addSADD = ({ form, pageItem, attachedItems, meta, store }) => {
    const variant = getVariantByParentType(meta?.ParentType ?? pageItem?.ParentType);
    const saddCollection = collection(variant, "SADDs");
    const saddCollectionTail = parentTypeFor(variant, "SADDs");
    const docCollection = collection(variant, "Documents");
    const docCollectionTail = parentTypeFor(variant, "Documents");
    const drawingCollection = collection(variant, "Drawings");
    const drawingCollectionTail = parentTypeFor(variant, "Drawings");
    const effectivityCollection = "Database/Effectivities";
    const effectivityCollectionTail = "Effectivities";
    const dqnCollection = collection(variant, "DQNs");
    const dqnCollectionTail = parentTypeFor(variant, "DQNs");
    const conCollection = collection(variant, "Concessions");
    const conCollectionTail = parentTypeFor(variant, "Concessions");
    const sbCollection = collection(variant, "ServiceBulletins");
    const sbCollectionTail = parentTypeFor(variant, "ServiceBulletins");
    const miscCollection = collection(variant, "Miscellaneous");
    const miscCollectionTail = parentTypeFor(variant, "Miscellaneous");
    const saddParentType = parentTypeFor(variant, "SADDs");

    const mdl = attachedItems[docCollectionTail].items.map(i => store.state[i]).find(doc => {
        return doc?.Type === (isRepairsParent(meta.ParentType) ? "REP" : "MDL");
    });
    let revisions = [];
    if (!!mdl) {
        revisions = Object.entries(mdl?.Revisions || {}).map(([key, value]) => {
            return {
                label: value.Revision,
                id: value.Revision
            };
        });

        form.setValues({
            "Number": `${variant.docPrefix}${(isRepairsParent(meta.ParentType) ? "SADD_" : "")}${pageItem.Number}_${Object.keys(pageItem.SADDs || {}).length + 1}`,
            [docCollectionTail]: [mdl?.ID]
        })
    } else {
        form.setValues({
            "Number": `${variant.docPrefix}${(isRepairsParent(meta.ParentType) ? "SADD_" : "")}${pageItem.Number}_${Object.keys(pageItem.SADDs || {}).length + 1}`,
        });
    }

    form.setConfig({
        "title": "Add SADD",
        "type": "push",
        "location": saddCollection,
        "fields": [{
            "label": "Number",
            "name": "Number",
            "type": "text"
        }, {
            "label": "SADD Type",
            "name": "Type",
            "type": "dropdown",
            "required": true,
            "dropdownData": ["Installation", "Manufacture", "Testing"].map(i => ({ label: i, id: i }))
        }, {
            "label": "POA/Arrangement",
            "name": "To",
            "type": "text",
            show({ liveInputData }) {
                return liveInputData.Type === "Manufacture";
            }
        }, {
            "label": "POA/Arrangement",
            "name": "To",
            "type": "value",
            show({ liveInputData }) {
                return liveInputData.Type !== "Manufacture";
            },
            value() {
                return "N/A";
            }
        }, {
            "label": "Date Issued",
            "name": "Date[Issued]",
            "type": "date"
        }, {
            "divClass": "col-span-3",
            "break": true
        }, {
            "label": "Select Documents",
            "name": docCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[docCollectionTail]?.items, "Number", "ID"),
            "divClass": "col-span-2"
        }, {
            "label": "Select MDL Revision",
            "name": "MDL[Revision]",
            "type": "dropdown",
            "required": false,
            "dropdownData": revisions
        }, {
            "divClass": "col-span-3",
            "break": true
        }, {
            "label": "Select Drawings",
            "name": drawingCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[drawingCollectionTail]?.items, "Number", "ID")
        }, {
            "label": "Select Effectivities",
            "name": effectivityCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[effectivityCollectionTail]?.items, "Number", "ID")
        }, {
            "label": "Select DQN's",
            "name": dqnCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[dqnCollectionTail]?.items, "Number", "ID")
        }, {
            "label": "Select Concession's",
            "name": conCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[conCollectionTail]?.items, "Number", "ID")
        }, {
            "label": "Select Service Bulletin's",
            "name": sbCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems?.[sbCollectionTail]?.items, "Number", "ID")
        }, {
            "label": "Select Miscellaneous / 3rd Party Items",
            "name": miscCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[miscCollectionTail]?.items, "Number", "ID")
        }],
        preSubmitHook({ data }) {
            return {
                "Date": {
                    "Created": (new Date()).toISOString(),
                    "Cancelled": "N/A",
                    "Signedoff": "N/A",
                    "Issued": data.Date["Issued"] || "N/A"
                },
                "Cancelled": false,
                "Parent": pageItem.Number,
                "ParentID": pageItem.ID,
                "ParentType": meta.ParentType,
                [docCollectionTail]: makeAttached(data[docCollectionTail]),
                [drawingCollectionTail]: makeAttached(data[drawingCollectionTail]),
                [sbCollectionTail]: makeAttached(data[sbCollectionTail]),
                [effectivityCollectionTail]: makeAttached(data[effectivityCollectionTail]),
                [dqnCollectionTail]: makeAttached(data[dqnCollectionTail]),
                [conCollectionTail]: makeAttached(data[conCollectionTail]),
                [miscCollectionTail]: makeAttached(data[miscCollectionTail]),
                "To": data.To || "N/A",
                "Number": data.Type === "Manufacture" ? data.Number + "M" : data.Type === "Testing" ? data.Number + "T" : data.Number
            }
        },
        async postSubmitHook({ db, typeRef, data }) {
            await db.set(`Database/${meta.ParentType}/${pageItem.ID}/${saddCollectionTail}/${typeRef.key}`, true);
            await db.utils.addAllTo(data, docCollection, docCollectionTail, saddParentType);
            await db.utils.addAllTo(data, drawingCollection, drawingCollectionTail, saddParentType);
            await db.utils.addAllTo(data, effectivityCollection, effectivityCollectionTail, saddParentType);
            await db.utils.addAllTo(data, dqnCollection, dqnCollectionTail, saddParentType);
            await db.utils.addAllTo(data, conCollection, conCollectionTail, saddParentType);
            await db.utils.addAllTo(data, sbCollection, sbCollectionTail, saddParentType);
            await db.utils.addAllTo(data, miscCollection, miscCollectionTail, saddParentType);
        }
    });
    form.getDropdownData();
    form.toggle();
};

export const editSADD = async ({ form, item, attachedItems, meta, pageItem }) => {
    const variant = getVariantByParentType(meta?.ParentType ?? item?.ParentType ?? pageItem?.ParentType);
    const saddCollection = collection(variant, "SADDs");
    const docCollectionTail = parentTypeFor(variant, "Documents");
    const drawingCollectionTail = parentTypeFor(variant, "Drawings");
    const effectivityCollectionTail = "Effectivities";
    const dqnCollectionTail = parentTypeFor(variant, "DQNs");
    const conCollectionTail = parentTypeFor(variant, "Concessions");
    const sbCollectionTail = parentTypeFor(variant, "ServiceBulletins");
    const miscCollectionTail = parentTypeFor(variant, "Miscellaneous");

    const mdl = attachedItems[docCollectionTail].items.map(key => store.state[key]).find(doc => {
        return doc.Type === "MDL";
    });

    let revisions = Object.entries(mdl?.Revisions || []).map(([key, value]) => {
        return {
            label: value.Revision,
            id: key
        };
    });

    form.setValues({
        ...item,
        "Date[Issued]": item.Date.Issued,
        "MDL[Revision]": item.MDL?.Revision,
        [docCollectionTail]: Object.keys(item[docCollectionTail] || {}),
        [drawingCollectionTail]: Object.keys(item[drawingCollectionTail] || {}),
        [effectivityCollectionTail]: Object.keys(item[effectivityCollectionTail] || {}),
        [sbCollectionTail]: Object.keys(item[sbCollectionTail] || {}),
        [dqnCollectionTail]: Object.keys(item[dqnCollectionTail] || {}),
        [conCollectionTail]: Object.keys(item[conCollectionTail] || {}),
        [miscCollectionTail]: Object.keys(item[miscCollectionTail] || {})
    });
    form.setConfig({
        "title": "Update SADD",
        "type": "update",
        "location": `${saddCollection}/${item.ID}`,
        "set": true,
        "fields": [{
            "label": "Number",
            "name": "Number",
            "type": "text"
        }, {
            "label": "SADD Type",
            "name": "Type",
            "type": "dropdown",
            "required": true,
            "dropdownData": ["Installation", "Manufacture", "Testing"].map(i => ({ label: i, id: i }))
        }, {
            "label": "POA/Arrangement",
            "name": "To",
            "type": "text"
        }, {
            "label": "Date Issued",
            "name": "Date[Issued]",
            "type": "date"
        }, { divClass: "col-span-3", break: true }, {
            "label": "Select Documents",
            "name": docCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[docCollectionTail]?.items, "Number", "ID"),
            "divClass": "col-span-2"
        }, {
            "label": "Select MDL Revision",
            "name": "MDL[Revision]",
            "type": "dropdown",
            "required": false,
            "dropdownData": revisions
        }, { divClass: "col-span-3", break: true }, {
            "label": "Select Drawings",
            "name": drawingCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[drawingCollectionTail]?.items, "Number", "ID")
        }, {
            "label": "Select Effectivities",
            "name": effectivityCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[effectivityCollectionTail]?.items, "Number", "ID")
        }, {
            "label": "Select DQN's",
            "name": dqnCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[dqnCollectionTail]?.items, "Number", "ID")
        }, {
            "label": "Select Concession's",
            "name": conCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[conCollectionTail]?.items, "Number", "ID")
        }, {
            "label": "Select Service Bulletin's",
            "name": sbCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[sbCollectionTail]?.items, "Number", "ID")
        }, {
            "label": "Select Miscellaneous / 3rd Party Items",
            "name": miscCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[miscCollectionTail]?.items, "Number", "ID")
        }],
        preSubmitHook({ data }) {
            return {
                [docCollectionTail]: makeAttached(data[docCollectionTail]),
                [drawingCollectionTail]: makeAttached(data[drawingCollectionTail]),
                [sbCollectionTail]: makeAttached(data[sbCollectionTail]),
                [effectivityCollectionTail]: makeAttached(data[effectivityCollectionTail]),
                [dqnCollectionTail]: makeAttached(data[dqnCollectionTail]),
                [conCollectionTail]: makeAttached(data[conCollectionTail]),
                [miscCollectionTail]: makeAttached(data[miscCollectionTail])
            }
        }
    });
    await form.getDropdownData();
    form.toggle();
};

export const cancelSADD = ({ form, item, meta, pageItem }) => {
    const variant = getVariantByParentType(meta?.ParentType ?? item?.ParentType ?? pageItem?.ParentType);
    const saddCollection = collection(variant, "SADDs");

    form.setConfig({
        "title": "Cancel SADD",
        "description": `Are you sure you want to cancel SADD ${item.Number}?`,
        "type": "update",
        "location": `${saddCollection}/${item.ID}`,
        "fields": [],
        preSubmitHook() {
            return {
                "Cancelled": true,
                "Date/Cancelled": new Date().toISOString()
            }
        }
    });
    form.toggle();
};

export const linkSADD = ({ form, pageItem, meta }) => {
    const variant = getVariantByParentType(meta?.ParentType ?? pageItem?.ParentType);
    const saddCollection = collection(variant, "SADDs");
    const saddCollectionTail = parentTypeFor(variant, "SADDs");

    form.setConfig({
        "title": "Link SADD",
        "type": "update",
        "location": `Database/${meta.ParentType}/${pageItem.ID}`,
        "fields": [{
            "label": "SADD",
            "name": "SADD",
            "type": "dropdown",
            "labelKey": "Number",
            "idKey": "ID",
            "dataLocation": saddCollection,
            "search": true
        }],
        preSubmitHook({ liveInputData }) {
            return {
                "SADD": null,
                [`${saddCollectionTail}/${liveInputData.SADD}`]: true
            }
        },
        postSubmitHook({ db, liveInputData }) {
            db.update(`${saddCollection}/${liveInputData.SADD}/${meta.ParentType}/${pageItem.ID}`, true);
        }
    });
    form.getDropdownData();

    form.toggle();
};
